import { Link } from 'react-router-dom';
import logoDark from '../assets/logo-dark.png';
import logoLight from '../assets/logo-light.png';
import { site } from '../site';

export function Wordmark({
  to = '/',
  tone = 'ink',
  size = 'md',
}: {
  to?: string;
  tone?: 'ink' | 'onInk';
  size?: 'sm' | 'md' | 'lg';
}) {
  const heightClass = size === 'lg' ? 'h-[52px]' : size === 'sm' ? 'h-5' : 'h-[22px]';
  const src = tone === 'onInk' ? logoLight : logoDark;

  return (
    <Link to={to} className="inline-flex items-center">
      <img src={src} alt={site.name} className={`w-auto ${heightClass}`} />
    </Link>
  );
}
